<template>
    <div class="news_content">
        <div class="titlebg">
            <img   :src="src"/>
            <div class="newsLable">
                <el-row :gutter="5" >
                    <el-col  
                        :span="2"
                        v-for="(item, index) in lableList"
                        :key="index">
                        <div class="lableItem" @mouseover="handleMouseOver(index)"  @click="handleLable(index)" :class="item.isActive? 'active': ''">{{item.title}}</div>
                    </el-col> 
                </el-row>  
            </div>
        </div>
        <div class="content">
            <el-row :gutter="15" >
                <el-col  :md="12" :sm="24">
                    <div style="" class="contentItem">
                        <el-image 
                            style="width: 100%; height: 100% ;overflow: revert;"
                            :src="src1">
                        </el-image>
                        <div 
                            v-for="(item, index) in newsList"
                            :key="index">
                            <div v-if="index < 1" class="desc" @click="handleInfo(item.ID)" >
                                <div style="font-size:16px; text-align:center">{{item.title}}</div>
                                <div class="icon">{{item.summary}}</div>
                            </div>
                        </div>
                        
                    </div>
                </el-col>
                <el-col 
                    :md="12" 
                    :sm="24"
                    v-for="(item, index) in newsList"
                    :key="index">
                    <div class="newlist" v-if="index >= 1">
                        <div class="item" @click="handleInfo(item.ID)">
                            <div class="listTitle">{{item.title}}</div>
                            <div class="desc">{{item.summary}}</div>
                            <div  class="listInfo" >详情>></div>
                        </div>
                    </div>
                </el-col>
            </el-row>  
        </div>
    </div>    
</template>

<script>
import { Message } from 'element-ui'
export default {
  data() {
    return {
        lableList:[
            {
                title: '公司动态',
                isActive: true
            },
            {
                title: '政采新闻',
                isActive: false
            },
            {
                title: '技术分享',
                isActive: false
            }
        ],
        newsList:[],
        // src: require('@/assets/img/business/titlebg2.png'),
        src1: require('@/assets/img/news/1.png'),
        // 查询参数
        queryParams: {
          pagenum: 1,
          pagesize: 4,
          status: 3
        },

    }
  },
  created() {
    this.getpaperlist('');
  },
  methods: {
    handleInfo(id){
        this.$router.push("/fournav/articleDetails/" + id);  
    },
    getpaperlist(node){
        this.axios.post('/paper/list',{...this.queryParams,module:node})
        .then(response => {
            this.newsList = response.data.data.articles
        })
        .catch(error => {
            Message.error(error.response.data.msg || '请求出错了');
        });
    },
    handleMouseOver(index){
        console.log(index)
        let { lableList } = this
        lableList.forEach((e, i) => {
            e.isActive = i == index
        });
        this.lableList = lableList
        let text = lableList[index].title == '公司动态' ? '' : lableList[index].title
        this.getpaperlist(text);
    },
    handleLable(index){

        let { lableList } = this

        // console.log(lableList[index].title)
        // lableList.forEach((e, i) => {
        //     e.isActive = i == index
        // });
        // this.lableList = lableList
    }
  },
}
</script>  

<style lang="scss" scoped>

    .news_content{
        width: 100%;
        padding-top: 45px;
        box-sizing: border-box;
        background: #F7F7F7;
        .titlebg{
            width: 70%;
            margin: 0 auto;
            img{
                width: 100%;
            }
            .newsLable{
                .lableItem{
                    cursor:pointer;
                    margin-top: 25px;
                    border: 1px solid #A81F27;
                    text-align: center;
                    margin-bottom: 43px;
                }
                .active{
                    cursor:pointer;
                    background: #A81F27 !important;
                    color: #fff !important;
                }
            }
        }
        .content{
            padding-top: 25px;
            padding-bottom: 25px;
            width: 70%;
            margin: 0 auto;
            .contentItem{
                .desc{
                    margin: 20px 0 30px;
                    padding: 15px 15px 25px;
                    box-sizing: border-box;
                    border-radius: 5px;
                    background: #fff;
                    .icon{
                        margin-top: 20px;
                    }
                }
            }
            .newlist{
                cursor:pointer;
                background: #fff;
                border-radius: 5px;
                margin-bottom: 15px;
                padding: 6px 0 1px 18px;
                .item{
                    .listTitle{
                        padding: 5px 0;
                        border-bottom:1px solid #A81F27 ;
                    }
                    .desc{
                        padding: 10px 0;
                    }
                    .listInfo{
                        text-align:right;
                        padding-right: 30px; 
                        padding-bottom: 10px;
                    }
                }
                
            }
            .newlist:hover{
                cursor:pointer;            
                box-shadow: -3px 3px 6px 3px rgba(225,35,35,0.48); 
                .item{
                    .listTitle,.listInfo{
                        color: #A81F27;
                    }
                    
                }
            }
        }

    }
</style>
